import RTL from 'theme/RTL.jsx';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from 'redux/store';
import ErrorBoundaries from 'components/ErrorBoundaries/ErrorBoundaries';
import TagManager from 'react-gtm-module';
import googletagmanagerId from 'services/googletagmanagerId';
import reportWebVitals from './reportWebVitals';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import 'assets/icon/css/keepaapp.css';
import 'assets/scss/reset.scss';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

if (googletagmanagerId()) {
	const tagManagerArgs = {
		gtmId: googletagmanagerId(),
	};

	TagManager.initialize(tagManagerArgs);
}

ReactDOM.render(
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<BrowserRouter>
			<QueryParamProvider adapter={ReactRouter6Adapter}>
				<ToastContainer
					position="top-center"
					hideProgressBar
					closeOnClick
					draggable
					pauseOnHover
					pauseOnFocusLoss
					rtl
					closeButton={false}
					autoClose={1000}
				/>
				<RTL>
					<ErrorBoundaries>
						<App />
					</ErrorBoundaries>
				</RTL>
				</QueryParamProvider>
			</BrowserRouter>
		</PersistGate>
	</Provider>,
	document.getElementById('root'),
);

serviceWorkerRegistration.register({
	// onUpdate: () => {},
	// onSuccess: () => {},
});

reportWebVitals();
